import React from 'react';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import SlidersListContentComponent from './SlidersListContentComponent';

class SlidersListComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <SlidersListContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default SlidersListComponent;